module.exports = __webpack_public_path__ + "img/emoji_88.2f3cf36e.png";